import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delegates',
  templateUrl: './delegates.component.html',
  styleUrls: ['./delegates.component.scss']
})
export class DelegatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
